import { phoneNumberFormatE164 } from "./phoneLib";

export function parseSmsProtocolPhone(url: string): string | null {
  let decoded = url;
  try {
    decoded = decodeURIComponent(url);
  } catch {
    // keep raw
  }

  let remainder = decoded.replace(/^sms:/i, "").split("?")[0];
  remainder = remainder.replace(/;body=[^;]*/i, "");
  remainder = remainder.replace(/^;+/, "");

  const phoneRaw = remainder
    .split(",")
    .map((segment) => segment.split(";")[0].trim())
    .find((segment) => /^(?=.*\d)[\d+]+$/.test(segment)) ?? "";

  if (!phoneRaw) return null;

  const formatted = phoneNumberFormatE164(phoneRaw);
  if (formatted) return formatted;
  return /\d/.test(phoneRaw) ? phoneRaw : null;
}
